export default "__VITE_ASSET__B1OfNEYIlaEPRsGyT7e3Gg__"